import { Link } from "react-router-dom";

import PageBanner from "../../layouts/PageBanner";
import { EducationSupport } from "../../constant/theme";

const SpokenEnglishCourse = () => {
    
  const teamData = [
    // 2022–23, 2023–24, 2024–25, 2025–26
    ["Akhil Farook", "Amiithesh Dhanuskodi", "Adrith Iyer", "Afra Serafin John Sathishbabu"],
    ["Amiithesh Dhanuskodi", "Aventhi", "Afra Serafin John Sathishbabu", "Ashwin Rajesh"],
    ["Ashish Farook", "Chandrabose Senthilkumar", "Dhiyasri Thirumurugan", "Harini Sadhish"],
    ["Aventhi", "Dhiyasri Thirumurugan", "Joshitha Jasper Premkumar", "Jithesh Santhanakrishnan"],
    ["Chandrabose Senthilkumar", "Joshitha Jasper Premkumar", "Joshitha Loganathan", "Joshitha Jasper Premkumar"],
    ["Laya Thumati Chandrasekharan", "Joshitha Loganathan", "Kavingiri Selvagiri", "Nanthana Bhavani Satish Kumar"],
    ["Saadhana Vijay", "Lakshitha", "Mihira Premanand", "Sachin Kumar"],
    ["Shaivi Ashok", "Saadhana Vijay", "Mridula Ramalingam", "Sandhya Suresh"],
    ["Tanya Suresh", "Sarayu Lokeshkumar", "Nanthana Bhavani Satish Kumar", "Sanjay Rajaguru"],
    ["Vishal Vijay", "Shanto", "Saadhana Vijay", "Sanjith Sundar Kalicharan"],
    ["", "Sneha Gupta", "Sachin Kumar", "Shravya Suresh"],
    ["", "Taarika Udayakumaran", "Sanjay Rajaguru", "Shruti Sathish"],
    ["", "Tanya Suresh", "Shravya Suresh", "Sivakami Subramanian"],
    ["", "Vikas Vijay", "Sivakami Subramanian", "Srikrishna Gunasekaran"],
    ["", "Vishal Vijay", "Sneha Gupta", "Taarika Udayakumaran"],
    ["", "", "Steffi Maria Oviya Premkumar", "Vikas Vijay"],
    ["", "", "Taarika Udayakumaran", ""],
    ["", "", "Tejesh Mayuran Sathyan", ""],
    ["", "", "Vikas Vijay", ""],
    ["", "", "", ""],
  ];

  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="Project" />

        <section className="content-inner bg-light section-pattren1">
          <div className="container">
            <div className="row align-items-center flex-column-reverse flex-lg-row">
              <div className="col-lg-12 align-self-center">
                <div className="section-head m-b30">
                  <h2 className="title mb-3 padding">
                    Spoken English Course - A SATS Youth Wing Initiative {" "}
                  </h2>
                </div>
              </div>
            </div>

            <div className=" dz-card blog-single sidebar">
              <div>
                {/* <div className="dz-meta">
                  <ul>
                    <li className="post-date">
                      <i className="fa-solid fa-calendar-days"></i> September,
                      2025
                    </li>
                
                  </ul>
                </div> */}
                <div className="dz-post-text">
                  <div>
                    <p> <span style={{fontSize:"18px", fontWeight: "bold" }}>
                      Overview
                      </span>
                      <br />
                      SATS Youth Wing proudly presents the Spoken English Course—an educational program designed 
                      to empower students in India with strong communication skills through engaging, interactive
                       learning. What began as a small volunteer effort has now grown into a large, structured, and
                        impactful initiative connecting students and youth tutors across continents. 
                    </p>
                      <p>
                         <span style={{ fontSize:"18px",  fontWeight: "bold" }}>
                      Our Tutors
                      </span>
                      <br />
                      The heart of this program is our dedicated team of high-school volunteers from San Antonio. 
                      These students, currently in high school (9th, 10th , 11th , and 12th grades),
                       commit their time beyond regular schoolwork, projects, and college preparation 
                       to teach and mentor younger learners. 
                    </p>

<div className="table-responsive shadow-sm rounded">
              <table className="table table-bordered text-center mb-5">
                <thead style={{ backgroundColor: "#1F618D", color: "white" }}>
                  <tr>
                    <th>2022–23 Team</th>
                    <th>2023–24 Team</th>
                    <th>2024–25 Team</th>
                    <th>2025–26 Team</th>
                  </tr>
                </thead>
                <tbody>
                  {teamData.map((row, idx) => (
                    <tr
                      key={idx}
                      style={{
                        backgroundColor: idx % 2 === 0 ? "#D6EAF8" : "#EAF2F8",
                      }}
                    >
                      {row.map((cell, cidx) => (
                        <td key={cidx}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
              <br />
            <p>Each tutor is paired with a parent volunteer, creating a strong support system for planning, coordination, and student engagement. </p>
            <p>
                 <span style={{ fontSize:"18px", fontWeight: "bold" }}>
                Growth Over the Years 
                </span>
                <br/>
                The Spoken English Course has expanded significantly in both participation and impact.
            </p>
            <p> <span style={{  fontSize:"18px", fontWeight: "bold" }}>
                1. Tutor & Parent Volunteers </span>
                <br/>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{   fontWeight: "bold" }}>• 2022–23: </span>10 tutors + 10 parents<br/>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{   fontWeight: "bold" }}>• 2023–24: </span>15 tutors + 15 parents<br/>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{  fontWeight: "bold" }}>• 2024–25:</span> 20 tutors + 20 parents <br/>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{   fontWeight: "bold" }}>• 2024–25:</span> 16 tutors + 16 parents 
            </p>
            <p>
                 <span style={{ fontSize:"18px", fontWeight: "bold" }}>2. Student Enrollment </span><br/>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{  fontWeight: "bold" }}>• 2022–23: </span>14 students (9th Std)  <br/>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{  fontWeight: "bold" }}>• 2023–24:</span> 20 students (9th Std)  <br/>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{  fontWeight: "bold" }}>• 2024–25:</span> 45 students (6th–9th Std)  <br/>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{  fontWeight: "bold" }}>• 2024–25:</span> 50-60 students (6th–9th Std) <br/>
                To support this growth, the program now operates across  <span style={{fontWeight: "bold" }}>two smart classrooms, </span>enabling more personalized attention and smoother learning experiences. 
            </p>
            <p> <span style={{  fontSize:"18px", fontWeight: "bold" }}>
                How the Program Works </span>
                <br/>
                The course is delivered through a well-organized, multi-modal teaching approach that blends technology, interactive content, and real-time guidance. 
                <br/><br/>
                <span style={{   fontWeight: "bold" }}>• Live online classes </span>conducted via Zoom  <br/>
                <span style={{   fontWeight: "bold" }}>• Two smart classrooms</span> equipped for hybrid learning <br/>
                 <span style={{   fontWeight: "bold" }}>• Tutors and students connected across ~12,000 km</span>  <br/>
                 <span style={{   fontWeight: "bold" }}>• Dynamic teaching methods,</span> including:   
                 <br/>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;o PowerPoint-based lessons <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;o YouTube video learning <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;o IXL practice exercises <br/>
                                <span style={{   fontWeight: "bold" }}>• Flexible syllabus,</span> adjusted continuously to match each class’s learning pace 

                  </p>
            
           
            <p><span style={{ fontSize:"18px",  fontWeight: "bold" }}>
                Program Scale </span>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• ~70 tutoring sessions per academic year  <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• ~200 slides of curated study material  <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• ~2,500 hours of total student learning per academic year   <br/>
                  This structure ensures that every student receives consistent, high-quality instruction while staying actively engaged. 
            </p>
            <p><span style={{  fontSize:"18px", fontWeight: "bold" }}>
                Course Highlights </span>
                <br/>
                The Spoken English Course focuses on building confidence, fluency, and practical communication skills. Students participate in: <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• Vocabulary development <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• Grammar fundamentals <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• Speaking and listening practice<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• Real-life conversation scenarios<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• Interactive activities and assessments <br/>
                  The combination of youth-led teaching and modern learning tools creates a relatable, motivating environment for students.
            </p>
            <p><span style={{  fontSize:"18px", fontWeight: "bold" }}>
                SATS Support </span>
                <br/>
                To facilitate the Spoken English classes in the two smart classrooms in India, we have hired two English teachers. They help with <br/>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• connecting to the zoom sessions every morning,  <br/>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• responding to student questions,  <br/>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• distributing printed assignments <br/>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• correcting homework and assignments<br/>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;• providing feedback on student performance etc.<br/>
                   As extension of their community projects, SATS pays their monthly salaries for the duration of the Spoken English course and also pays for technical support for setting up the computer equipment to ensure their continued functioning during the sessions.  
                 </p>
                   <p><span style={{  fontSize:"18px", fontWeight: "bold" }}>
                    A Note of Gratitude </span><br/>
                    We extend our heartfelt thanks to the SATS community, parent volunteers, and the students who trust us with their learning journey. Most importantly, we celebrate our youth tutors whose dedication, compassion, and leadership make this program possible. 
                    </p>
                    
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                     <i>
                    “Thank you for giving us this wonderful opportunity to teach and share our knowledge with you.” 
                     </i>
                    </div>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SpokenEnglishCourse;
